import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

interface ToastItem {
  id: number;
  text: string;
  kind: 'ok' | 'error';
}
const Ctx = createContext<{ toast: (text: string, kind?: 'ok' | 'error') => void }>({ toast: () => {} });
let seq = 0;

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<ToastItem[]>([]);
  const dismiss = useCallback((id: number) => setItems((l) => l.filter((t) => t.id !== id)), []);
  const toast = useCallback(
    (text: string, kind: 'ok' | 'error' = 'ok') => {
      const id = ++seq;
      setItems((l) => [...l, { id, text, kind }]);
      // Fehler bleiben länger stehen und lassen sich wegklicken
      setTimeout(() => dismiss(id), kind === 'error' ? 10000 : 2600);
    },
    [dismiss],
  );
  const value = useMemo(() => ({ toast }), [toast]);
  return (
    <Ctx.Provider value={value}>
      {children}
      <div className="toast-wrap" role="status" aria-live="polite">
        {items.map((t) =>
          t.kind === 'error' ? (
            <div key={t.id} className="toast error" role="alert">
              <span>{t.text}</span>
              <button type="button" className="toast-x" aria-label="Schließen" onClick={() => dismiss(t.id)}>
                ×
              </button>
            </div>
          ) : (
            <div key={t.id} className="toast">
              {t.text}
            </div>
          ),
        )}
      </div>
    </Ctx.Provider>
  );
}
export const useToast = () => useContext(Ctx).toast;
